import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import _map from 'lodash/map';
import _join from 'lodash/join';
// Local files
import BaseAnalysesListItem from 'components/Analyses/Common/BaseAnalysesListItem/BaseAnalysesListItem';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const Item = ({ id, inputs, status, updated_at }) => { 
  const navigate = useNavigate();
  
  const handleClick = (id) => navigate(`/flow/fl66p/${id}`);
 
  return (
    <BaseAnalysesListItem
      id={id}
      input={_join(_map(inputs, 'filename'), ', ')}
      status={status}
      updated_at={updated_at}
      handleClick={handleClick}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Item {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);